module.exports = __webpack_public_path__ + "static/todo-app-bbfe5d31d782be82818e80df01d66653.jpg";